import Stores from './containers/Stores';
import StoresLeftSide from './containers/StoresLeftSide';
import { storesSelectors, StoresState } from './services/selectors';
import epics from './services/epics';
import reducer from './services/reducer';

export { storesSelectors, epics, StoresState, reducer, StoresLeftSide };

export default Stores;



// WEBPACK FOOTER //
// ./src/scenes/Stores/index.ts